"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RawEditComponent = void 0;
var react_1 = __importDefault(require("react"));
var redux_form_1 = require("redux-form");
var EditComponent = function (_a) {
    var _b = _a.component, component = _b === void 0 ? 'input' : _b, handleSubmit = _a.handleSubmit, idx = _a.idx, dirty = _a.dirty, onFocus = _a.onFocus, onBlur = _a.onBlur, cellInEdit = _a.cellInEdit, wrapperClass = _a.wrapperClass, disabled = _a.disabled;
    return react_1["default"].createElement("div", { className: wrapperClass },
        react_1["default"].createElement(redux_form_1.Field, { autoFocus: cellInEdit, name: idx, component: component, className: 'form-control', onFocus: onFocus, onBlur: function (evt, value, prev) {
                if (dirty) {
                    handleSubmit();
                }
                onBlur();
            }, disabled: disabled, normalize: function (v) { return typeof v === 'boolean' ? (v === true ? '1' : '0') : v; } }));
};
exports.RawEditComponent = EditComponent;
// @ts-ignore
exports["default"] = (0, redux_form_1.reduxForm)({})(EditComponent);
